// 标签颜色
export enum ETagColor {
  GREEN,
  ORANGE,
  GREY,
}
